(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7428],{

/***/ 449:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/london/seo-design-portfolio/wordpress-seo-agency",
      function () {
        return __webpack_require__(8163);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_blocks_portfolio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(362);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9472);
/* harmony import */ var components_common_SEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2034);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4870);
/* harmony import */ var components_common_ProjectDetailsNavigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4153);
/* harmony import */ var components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9266);








var details = {
    pageName: "London Hair by Jackie",
    categories: "seo, ppc, social, web design",
    description: "London Hair by Jackie is a high end wig store based in London. We were asked to design and develop a new ecommerce site for them. We also provided SEO, PPC and social media services.",
    parentDirectories: "seo-design-portfolio"
};
var Portfolio = data_keywords__WEBPACK_IMPORTED_MODULE_5__.LocalSEOArrays[5].keywords;
var ProjectDetails = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_SEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        title: "".concat(Portfolio[0].title, " - ").concat(details.pageName),
                        description: details.description,
                        tag: details.categories,
                        urlPT: "",
                        urlENPT: "",
                        url: "".concat(Portfolio[0].url, "/").concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-")),
                        image: "/img/clients/".concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "wrapper image-wrapper bg-image bg-overlay text-white",
                        style: {
                            backgroundImage: "url(/img/clients/" + Portfolio[1].title.toLowerCase().replace(/ /g, "-") + "-bg.jpg)",
                            backgroundSize: "cover"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container pt-17 pb-12 pt-md-19 pb-md-16 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "post-header",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: "fs-15 text-uppercase text-white mb-3",
                                                children: Portfolio[0].title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "display-4 text-capitalize mx-auto",
                                                children: details.pageName
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "wrapper bg-light wrapper-border",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container pt-14 pt-md-16 pb-13 pb-md-15",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-lg-12 offset-lg-0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "display-6 mb-4",
                                            children: details.pageName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "col-md-8 text-justify",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                className: "caption",
                                                                children: details.description
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            children: [
                                                                "At SEOptimist  ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                    title: data_keywords__WEBPACK_IMPORTED_MODULE_5__.HomeList[0].title,
                                                                    href: "/"
                                                                }),
                                                                ", we understand that a website is more than just a collection of web pages. It's a representation of a business's brand and values, and it must be designed to meet the client's goals. London Hair by Jackie is an online WooCommerce store selling natural wigs."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            children: Portfolio[3].title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "The client approached us in February 2023 with a problem. Their website was built on an outdated theme that was incompatible with their SEO requirements. Our team of WordPress SEO experts analyzed their website and recommended a migration to a new theme that was more SEO-friendly and could improve the site's overall performance."
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            width: "100%",
                                                            height: "auto",
                                                            src: "/img/clients/".concat(Portfolio[2].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                            alt: Portfolio[2].title,
                                                            style: {
                                                                background: "transparent"
                                                            },
                                                            className: "mb-5 mw"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            children: Portfolio[2].title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "We began by performing a comprehensive website audit, identifying the issues that needed to be addressed, and creating a detailed migration plan. We then migrated the site to a new SEO-optimized WordPress theme, ensuring that all pages, content, and data were correctly transferred."
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            children: Portfolio[1].title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Once the migration was complete, our team implemented an on-page SEO strategy that included optimizing the website's titles, meta descriptions, headers, and content to improve its relevance to search engines. We also optimized the site's images, speed, and mobile-friendliness, making it easier for users to navigate and find the products they were looking for."
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            width: "100%",
                                                            height: "auto",
                                                            src: "/img/clients/".concat(Portfolio[3].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                            alt: Portfolio[3].title,
                                                            style: {
                                                                background: "transparent"
                                                            },
                                                            className: "mb-5 mw"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            children: Portfolio[4].title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            children: [
                                                                "Through our efforts, London Hair by Jackie's website has seen a significant improvement in its search engine rankings (from page 5 to the top of page 2 for several terms within 8 weeks), organic traffic, and overall performance. The client was thrilled with the results and reported a substantial increase in online sales. SEOptimist is on target to achieve page 1 rankings within 3 months. - ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                                    children: "1/04/23"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            children: [
                                                                "At SEOptimist  ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                    title: data_keywords__WEBPACK_IMPORTED_MODULE_5__.HomeList[2].title,
                                                                    href: "/"
                                                                }),
                                                                ", we're committed to delivering measurable results to our clients. We understand that every business has unique SEO requirements, and we offer customized solutions that fit their needs. Contact us today to learn more about our WordPress SEO services and how we can help your business achieve success online."
                                                            ]
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "col-md-4 ms-auto",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            width: 250,
                                                            height: "auto",
                                                            src: "/img/clients/".concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                            alt: Portfolio[0].title,
                                                            style: {
                                                                background: "transparent"
                                                            },
                                                            className: "mb-5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            className: "list-unstyled",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                            className: "mb-1",
                                                                            children: "Categories"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            children: details.categories
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                            className: "mb-1",
                                                                            children: "Client Name"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            children: details.pageName
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    title: "Get in touch",
                                                    href: "/#contact",
                                                    className: "more hover"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_portfolio__WEBPACK_IMPORTED_MODULE_2__/* .LocalSEO */ .wx, {
                                                    initialslide: 0
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ProjectDetailsNavigation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                location: "london"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectDetails);


/***/ }),

/***/ 4153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var ProjectDetailsNavigation = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "wrapper bg-light"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProjectDetailsNavigation);


/***/ }),

/***/ 9266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 873).then(__webpack_require__.bind(__webpack_require__, 873));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(873)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Free Consultation",
                    body: "Reach out to us and we will get back to you right away with a customised plan to get you more sales.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 959:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var useIsotope = function() {
    var isotope = useRef();
    var ref = useState("*"), filterKey = ref[0], setFilterKey = ref[1];
    useEffect(function() {
        if (false) {}
        _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var Isotope, grids;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return __webpack_require__.e(/* import() */ 3391).then(__webpack_require__.t.bind(__webpack_require__, 3391, 23));
                    case 2:
                        Isotope = _ctx.sent.default;
                        grids = document.querySelectorAll(".grid");
                        if (grids !== null) {
                            grids.forEach(function(g) {
                                var grid = g.querySelector(".isotope");
                                isotope.current = new Isotope(grid, {
                                    itemSelector: ".item",
                                    layoutMode: "masonry",
                                    masonry: {
                                        columnWidth: grid.offsetWidth / 12
                                    },
                                    percentPosition: true,
                                    transitionDuration: "0.7s"
                                });
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
        return function() {
            var ref;
            return (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.destroy();
        };
    }, []);
    useEffect(function() {
        var ref;
        var filtered = filterKey === "*" ? {
            filter: "*"
        } : {
            filter: filterKey
        };
        (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.arrange(filtered);
    }, [
        filterKey
    ]);
    // change filter item
    var handleFilterKeyChange = function(key) {
        return function() {
            return setFilterKey(key);
        };
    };
    return {
        handleFilterKeyChange: handleFilterKeyChange,
        filterKey: filterKey
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useIsotope)));


/***/ }),

/***/ 2783:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var carouselBreakpoints = {
    0: {
        slidesPerView: 1
    },
    768: {
        slidesPerView: 2
    },
    1200: {
        slidesPerView: 3
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (carouselBreakpoints);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,4870,4556,6435,362,9774,2888,179], function() { return __webpack_exec__(449); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);